import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from 'notistack';
import * as React from 'react';
import { useWizard } from '../../design-system';
import { errorSnackbar } from '../ErrorSnackbar';

type Props = { onSubmit: () => Promise<void>; itemBeingCreated: string };

export const WizardConfirmationStep: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  itemBeingCreated,
  onSubmit,
}) => {
  const { prevStep } = useWizard();
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();

  const [isSubmitting, setSubmitting] = React.useState<boolean>(false);

  const submitForm = React.useCallback(() => {
    setSubmitting(true);
    onSubmit().catch((e) => {
      errorSnackbar(`Unable to create ${itemBeingCreated}`, closeSnackbar, enqueueSnackbar, e);
      setSubmitting(false);
    });
    return () => {
      setSubmitting(false);
    };
  }, [closeSnackbar, enqueueSnackbar, onSubmit, itemBeingCreated]);

  return (
    <>
      {children}
      <Box pt={2} display="flex">
        <Button color="inherit" disabled={isSubmitting} onClick={prevStep} variant="contained">
          Back
        </Button>
        <Box mr="auto" />
        <Button color="primary" disabled={isSubmitting} onClick={submitForm} variant="contained">
          {isSubmitting ? <CircularProgress size={24} color="inherit" /> : `Create ${itemBeingCreated}`}
        </Button>
      </Box>
    </>
  );
};
